import Image from "next/image";
import {Button} from "@/components/base/Buttons";
import styled from "styled-components";
import {breakpoints} from "@/styles/sizes";

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  margin: 150px 0;

    @media only screen and (${breakpoints.mobile}) {
        grid-template-columns: 1fr;
        padding: 20px;
        text-align: center!important;

        margin: 100px 0;
        
        
        li{
            text-align: left!important;
        }
    }
`;

export default function StaticPageTextImageSection({textImageSectionImage,description,buttonLink,buttonText}) {
    return <GridContainer>
        <Image
            className={'desktop_only'}
            width={650}
            height={650}
            src={textImageSectionImage?.url}
            alt={textImageSectionImage?.alt ?? textImageSectionImage?.name}
            style={{
                width: '100%',
                height: '550px',
                objectFit: 'cover',
            }}
        />

        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
        }}>
            <div style={{marginBottom:'30px'}} dangerouslySetInnerHTML={{__html: description}}/>
            {buttonText && <Button variant={'green'} href={buttonLink}>
                {buttonText}
            </Button>}
        </div>


    </GridContainer>
}
